export class IRegisterCompanyProfileData{
    nit: number | null = null;
    name: string = "";
    phoneContact: string = "";
    email: string = "";
}